export default {
  orderAmount: function()  {
    let amount = 0

    this.accommodations?.forEach(accommodation => {
      amount += accommodation.price * accommodation.quantity
    })

    this.optionals?.forEach(optionals => {
      amount += optionals.price * optionals.quantity
    })

    return amount
  }
}
